<template>
  <div id="notifiction">
    <v-snackbar
      :key="notification.id"
      :notification="notification"
      :timeout="timeout"
      bottom
      class="font-weight-light"
      color="#151B26"
      right
      v-for="notification in notifications"
      v-model="snackbar"
    >
      {{ notification.message }}
      <v-btn @click="snackbar = false" color="primary" dark flat>Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'notifiction',
  data() {
    return {
      timeout: 3000
    }
  },
  computed: {
    snackbar: {
      // getter
      get() {
        return this.notifications.length > 0 ? true : false
      },
      // setter
      set(newValue) {
        this.$store.dispatch('Notification/remove', this.notifications)
      }
    },
    notifications() {
      return this.$store.state.Notification.notifications
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Notifications.vue